export enum EntitiesEnum {
  PRODUCT = "product",
  BRAND = "brand",
  MANUFACTURER = "manufacturer",
  SUB_BRAND = "sub_brand",
  PRODUCT_LINE = "product_line",
  ATTRIBUTE = "attribute",
}
